module.exports = __webpack_public_path__ + "media/1x1/af-fa735e43.svg";